/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { parentVisitor } from "utils/DomUtils.js";

export const getContextMenuItems = stores => stores.contextMenuStore.menuItems;
export const getContextMenuXPosition = stores => stores.contextMenuStore.xPosition;
export const getContextMenuYPosition = stores => stores.contextMenuStore.yPosition;
export const isContextMenuVisible = stores => stores.contextMenuStore.menuItems.length > 0;
export const getClassNamesToDiableContextMenuOn = stores => stores.contextMenuStore.classNamesToDisableContentMenuOn;
export const getContextMenuTriggerType = stores => stores.contextMenuStore.triggerType;
export const getContextMenuTriggerBBox = stores => stores.contextMenuStore.triggerBBox;
export const getContextMenuTriggerZoomLevel = stores => stores.contextMenuStore.pageZoomLevel;
export const getIsContextMenu = stores => stores.contextMenuStore.isContextMenu;
export const getContextMenuDefaultPlacement = stores => stores.contextMenuStore.placement;
export const getContextMenuTriggerPageIndex = stores => stores.contextMenuStore.triggerPageIndex;
export const getContextMenuItemStyle = stores => stores.contextMenuStore.contextMenuItemStyle;
export const getContextMenuStyle = stores => stores.contextMenuStore.contextMenuStyle;
export const getTrapFocus = stores => stores.contextMenuStore.trapFocus;
export const getShouldTriggerContextMenuOnTextSelection = stores =>
  stores.contextMenuStore.shouldTriggerContextMenuOnTextSelection;

export const shouldEnableContextMenu = (stores, target) => {
  if (!target) return true;
  const blacklistedClassNames = getClassNamesToDiableContextMenuOn(stores);
  const callback = currentElement => {
    const elementClassNames = currentElement.classList;
    if (!elementClassNames) return false;
    for (let i = 0; i < elementClassNames.length; ++i) {
      const elementClass = elementClassNames[i];
      if (blacklistedClassNames.includes(elementClass)) {
        return true;
      }
    }
    return false;
  };
  if (parentVisitor(target, callback)) {
    return false;
  }
  return true;
};

export const getContextMenuTriggerEventObj = stores => stores.contextMenuStore.contextMenuTriggerEventObj;
export const getDisabledContextMenuVerbs = stores => stores.contextMenuStore.disabledVerbs;
export const getContextMenuHandle = stores => stores.contextMenuStore.contextMenuHandle;
